import React, { FC } from 'react';

import { PrimaryButton } from '@crehana/ui';

import { Shield } from '@crehana/icons';

import LegalCheckbox from 'Jsx/CheckoutV4/components/LegalCheckbox';
import NewsLetterCheckbox from 'Jsx/CheckoutV4/components/NewsLetterCheckbox';

import EmailInput, { EmailState } from '../../../UserInputFields/EmailInput';

interface Props {
  checkedTerms: boolean;
  onTermsChange: (checked: boolean) => void;
  newslettersTerms: boolean;
  onNewslettersTermsChange: (checked: boolean) => void;
  email: EmailState;
  onEmailChange: (email: EmailState) => void;
  onGenerateQr: () => void;
}

const UserDataStep: FC<Props> = ({
  checkedTerms,
  onTermsChange,
  newslettersTerms,
  onNewslettersTermsChange,
  email,
  onEmailChange,
  onGenerateQr,
}) => {
  const onFormSubmitted = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onGenerateQr();
  };

  return (
    <article>
      <header className="mb-24">
        <h2 className="font-subtitle3 mb-16">
          Realiza tu pago desde tu aplicación de Yape
        </h2>
        <p className="font-body4">
          Después de ingresar tu correo electrónico, se generará el código QR
          que podrás pagar con la aplicación de Yape. Recuerda que la
          confirmación de tu compra se notificará al correo electrónico que
          ingreses a continuación:
        </p>
      </header>

      <form onSubmit={onFormSubmitted}>
        <EmailInput onEmailChange={onEmailChange} />

        <LegalCheckbox
          className="mb-24"
          checkedTerms={checkedTerms}
          setCheckedTerms={onTermsChange}
        />

        <NewsLetterCheckbox
          className="mb-24"
          checkedNewsLetterTerms={newslettersTerms}
          setCheckedNewsLetterTerms={onNewslettersTermsChange}
        />

        <div className="w-full sm:max-w-360">
          <PrimaryButton
            type="submit"
            isAccent
            size="l"
            full
            disabled={!email?.isValid || !checkedTerms}
            label="Generar QR"
            leftIcon={{ component: Shield, size: 24 }}
          />
        </div>
      </form>
    </article>
  );
};

export default UserDataStep;
